const cleanStorageBeforeSearch = () => {
  sessionStorage.removeItem("carSearch");
  sessionStorage.removeItem("flySearch");
  sessionStorage.removeItem("busSearch");
  sessionStorage.removeItem("hotelSearch");
  sessionStorage.removeItem("experienceSearch");
  sessionStorage.removeItem("entertainmentSearch");
  sessionStorage.removeItem("packageSearch");
  sessionStorage.removeItem("buscaAtual");
  sessionStorage.removeItem("@EntertainmentSelected");
  sessionStorage.removeItem("@EntertainmentAvailabilitySelected");
  // Demanda 240 — o grupo do status é de UMA reserva; não pode vazar para a próxima.
  sessionStorage.removeItem("@booking-processing-group");
};

export default cleanStorageBeforeSearch;
